import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './header_.module.css'
import BtnLogin from './btn_login';
import { useRouter } from 'next/router';
import * as generalAction from '../../redux/action/general_action'
import BtnLogout from './btn_logout';
import strings from '../../strings/strings.json'

export default function HeaderMobile(props) {
    const router = useRouter()
    const dispatch = useDispatch()
    const state = useSelector(state => state.general_reducer)
   /*  const user = state.userInfo */

    return (
        <div className={styles.mobile_mode_container}>
            <div className={styles.drawer_container} onClick={() => dispatch(generalAction.setOpenDrawer(true))}>
                <img src="/assets/icons/open-menu.svg" alt="Icon" />
            </div>
            <div>{props.logo}</div>
            <div className={styles.mobile_mode_btn}>
               {/*  {
                    user.first_name === undefined || user.first_name === "guest" ?
                       'ss'
                        :
                        'ss'
                } */}

            </div>
        </div>
    )
}
